module.exports = __webpack_public_path__ + "img/congo-illustration.d9c216f1.png";